import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { closeSnackbar, enqueueSnackbar } from "notistack";
import { ReactComponent as CloseIcon } from "../../../assets/icons/portfolio/login-cross.svg";
import Button from "../../../components/button/Button";
import Header from "../../../components/header/Header";
import axios from "axios";
import "../WithdrawBank/WithdrawBank.css";
import "./WithdrawCrypto.css";

const WithdrawCrypto = () => {
  const { t } = useTranslation();
  const token = localStorage.getItem("token");
  const [hdnpp, setHdnpp] = useState(true);

  const [bankTransferAmount, setBankTransferAmount] = useState("");
  const [cryptoTransferVar, setCryptoTransferVar] = useState("");
  const [cryptoWallet, setCryptoWallet] = useState("");
  const [portfolioActive, setPortfolioActive] = useState();
  const [idbk, setIdbk] = useState();
  const [idcr, setIdcr] = useState();
  const [availableCoins, setAvailableCoins] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedCoin, setSelectedCoin] = useState("");

  const action = (snackbarId) => (
    <button className="close-button" onClick={() => { closeSnackbar(snackbarId) }}>
        <CloseIcon/>
    </button>
  );

  const transformCryptoData = (data) => {
    const result = [];

    // Проходим по ключам объекта
    for (let i = 1; i <= 5; i++) {
      if (data[`cryptoEnabled${i}`]) {
        result.push({
          [`cryptoTransferVar`]: data[`cryptoTransferVar${i}`],
          [`cryptoNet`]: data[`cryptoNet${i}`],
          [`cryptoCardNumber`]: data[`cryptoCardNumber${i}`],
        });
      }
    }

    return result;
  };

  // Получение списка доступных криптовалют
  const fetchCoinsAndAddress = async () => {
    setLoading(true);
    axios
      .get(`https://api-ru.fynex.cc/api/api/crypto/avilable`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setAvailableCoins(transformCryptoData(res.data));
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getUserPortfolioData = () => {
    axios
      .get("https://api-ru.fynex.cc/api/api/user/portfolio", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setPortfolioActive(res.data.withdrawDeny);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    getUserPortfolioData();
  }, []);

  const handleCryptoPayment = () => {
    axios
      .post(
        `https://api-ru.fynex.cc/api/api/users/balance/withdraw/crypto`,
        {
          balance_type: "main",
          value: bankTransferAmount,
          coin_to: selectedCoin,
          coin_from: selectedCoin,
          owner_details: cryptoWallet,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((res) => {
        // enqueueSnackbar(`Успешно!`, { action, 'variant': 'success', 'className': "snacksuccess" });
        // setHdnpp(false);
        // setIdcr(res.data);
        navigate("../withdraw-approve", { replace: true });
      })
      .catch((error) => {
        error.response.data.detail.map((errormsg) => {
          enqueueSnackbar(`${t("withdrawCrypto.err")}: ${errormsg.msg}`, {
            action,
            variant: "error",
            className: "snackerror",
          });
        });
      });
  };

  const handleCryptoStatus = () => {
    axios
      .get(`https://api-ru.fynex.cc/api/api/withdraw/bank/status?id=${idcr}`)
      .then((res) => {
        if (res.data === "accepted") {
          navigate(`../transactions`, { replace: true });
        } else if (res.data === "waiting") {
          setTimeout(() => handleCryptoStatus(), 2000);
        }
      })
      .catch((err) => {
        console.error(err);
          setTimeout(() => handleCryptoStatus(), 2000);
      });
  };

  let navigate = useNavigate();
  useEffect(() => {
    fetchCoinsAndAddress();
  }, []);

  return (
    <div className="WithdrawCrypto">
      <Header hasMenu2={true} />
      {portfolioActive ? (
        <h4 style={{ textAlign: "center", marginTop: 100 }}>
          {t("withdrawCrypto.concolusionNotAcess")}
        </h4>
      ) : (
        <div className="WithdrawCryptoWrapper">
          <h2>{t("withdrawCrypto.conclusion")}</h2>
          <div className="inputs">
            <select
              value={selectedCoin}
              onChange={(e) => setSelectedCoin(e.target.value)}
              style={{color: "white"}}
            >
              {loading ? (
                ""
              ) : (
                <option value="" disabled>
                  {t("withdrawCrypto.selectCurrency")}
                </option>
              )}
              {loading ? (
                <option value="" disabled>
                  {t("withdrawCrypto.load")}
                </option>
              ) : (
                availableCoins.map((coin) => (
                  <option
                    key={coin.cryptoTransferVar}
                    value={coin.cryptoTransferVar}
                  >
                    {coin.cryptoTransferVar.toUpperCase()} ({coin.cryptoNet})
                  </option>
                ))
              )}
            </select>
            <input
              type="text"
              placeholder={t("withdrawCrypto.adresCryptoWallet")}
              value={cryptoWallet}
              onChange={(e) => setCryptoWallet(e.target.value)}
            />
            <input
              type="number"
              placeholder={t("withdrawCrypto.sumOutput")}
              value={bankTransferAmount}
              onChange={(e) => setBankTransferAmount(e.target.value)}
            />
          </div>
          <p>{t("withdrawCrypto.warn")}</p>
          <Button
            text={t("withdrawCrypto.sendFrom")}
            onClick={handleCryptoPayment}
          />
        </div>
      )}
    </div>
  );
};

export default WithdrawCrypto;
